import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { tv as p } from "../tailwind-variants.config.js";
import { CheckedMarkIcon as h } from "./CheckedMarkIcon.js";
import { ErrorMessage as g } from "../ErrorMessage/index.js";
import { forwardRef as w } from "react";
const f = p({
  base: "jm-box-border jm-absolute jm-left-0 jm-top-2.5 jm-border peer-checked:jm-border-none jm-border-solid jm-pointer-events-none jm-w-6 jm-h-6 jm-rounded-[3px] jm-bg-white jm-border-jutro-new-warm-gray-500 peer-disabled:jm-bg-jutro-new-warm-gray-300 peer-checked:peer-disabled:jm-bg-jutro-new-warm-gray-300 peer-disabled:jm-border-jutro-new-warm-gray-300 peer-focus-visible:jm-outline peer-focus-visible:jm-outline-2",
  variants: {
    variant: {
      blue: "group-hover/checkbox:jm-bg-jutro-new-blue-50 group-active/checkbox:jm-bg-jutro-new-blue-400 peer-checked:jm-bg-jutro-new-blue-800 group-hover/checkbox:peer-checked:jm-bg-jutro-new-blue-900 group-hover/checkbox:peer-checked:peer-disabled:jm-bg-jutro-new-warm-gray-300 group-active/checkbox:peer-checked:jm-bg-jutro-new-blue-950 peer-focus-visible:jm-outline-jutro-new-blue-500"
    },
    error: {
      true: "jm-bg-white peer-checked:jm-bg-jutro-new-rose-600 jm-border-jutro-new-rose-600 jm-border-2 group-hover/checkbox:peer-checked:jm-bg-jutro-new-rose-600 group-active/checkbox:peer-checked:jm-bg-jutro-new-rose-600"
    }
  },
  defaultVariants: {
    variant: "blue"
  }
}), M = w((n, s) => {
  const {
    name: r,
    onChange: l,
    checked: o,
    onBlur: b,
    label: m,
    error: t,
    disabled: j,
    ...i
  } = n, u = typeof t == "string", d = f({
    error: !!t
  });
  return /* @__PURE__ */ c("div", { className: "jm-flex jm-flex-col", children: [
    /* @__PURE__ */ c(
      "div",
      {
        onClick: (a) => {
          a.stopPropagation(), !j && l({
            ...a,
            target: {
              ...a.target,
              checked: !o
            }
          });
        },
        className: "jm-group/checkbox jm-font-paragraph-1 jm-relative jm-box-border jm-flex jm-w-fit jm-cursor-pointer jm-select-none jm-py-2.5 jm-text-jutro-new-warm-gray-800 *:jm-pointer-events-none has-[:disabled]:jm-cursor-default *:has-[:disabled]:jm-text-jutro-new-warm-gray-500",
        children: [
          typeof m == "string" ? /* @__PURE__ */ e(
            "label",
            {
              htmlFor: r,
              className: "jm-pl-8",
              dangerouslySetInnerHTML: { __html: m }
            }
          ) : /* @__PURE__ */ e("label", { htmlFor: r, className: "jm-pl-8", children: m }),
          /* @__PURE__ */ e(
            "input",
            {
              ...i,
              id: r,
              ref: s,
              type: "checkbox",
              className: "jm-peer jm-m-0 jm-opacity-0",
              name: r,
              onBlur: b,
              checked: o,
              disabled: j
            }
          ),
          /* @__PURE__ */ e("div", { className: d, children: /* @__PURE__ */ e("span", { className: "jm-flex jm-h-full jm-w-full jm-items-center jm-justify-center", children: o && /* @__PURE__ */ e(h, {}) }) })
        ]
      }
    ),
    u && /* @__PURE__ */ e(g, { error: t })
  ] });
});
export {
  M as Checkbox
};
//# sourceMappingURL=index.js.map
